<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      泥岗站<br>
站点介绍<br>
泥岗站位于金碧路上，车站沿金碧路东西向布置。金碧路南侧包含深圳中学泥岗校区、深圳市第三职业技术学校、银湖学校，金碧路北侧包含凤光小学、泥岗村北侧。泥岗站是学生客流大站。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:35	23:15	9号线	3分50秒	5分55秒<br>
文锦	06:12	23:53	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:36	23:16	9号线	4分25秒	5分55秒<br>
文锦	06:11	23:53	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:36	00:16	9号线	4分钟	5分55秒<br>
文锦	06:09	00:53	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
金碧路南侧、金碧支路、深圳中学泥岗校区、泥岗西村、银湖学校、坭岗社区公园<br><br>
C出入口:<br>
金银园、星湖花园、大地苑、深圳市凤光小学、坭岗街心花园、泥岗北村、银晖名居、金碧路北侧<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 深中泥岗分校北<br>
69路<br><br>
C出入口:<br>
公交站名： 泥岗村北<br>
69路、B614路<br><br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>